import React, {
  useMemo,
  useState,
  useCallback,
  useEffect
} from 'react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import styles from '../stocktabpanel.module.scss';
import ShipmentConsignment from '../../../components/Shipment/_consignment';
import IncomingConsignment from '../../../components/Incoming/_consignment';
import PopupActMVP from '../../../components/PopupActMVP';
import Reports from '../../../components/Reports';
// import StockMetric from '../../../components/StockMetric';
import QRCodeTab from '../../../components/QRCodeTab';
import ResponsiblePerson from '../../../components/ResponsiblePerson';
import EditAct from '../../../components/EditAct';
import SalesOrders from '../../../components/SalesOrders';
import MessagesAdmin from '../../../components/AdminTabList/MessagesAdmin';

const StockTabPanelConsignment = ({
  isAutoAcceptIncoming,
  isHub,
  isUseAZH,
  isUseCheckShiptoAddress,
  isUseFIFO,
  isUseM4,
  plantId,
  showTranspOrder,
  tabsListState
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const savedTabSelect = Number(localStorage.getItem('tabSelect'));

  useEffect(() => {
    if ((savedTabSelect || savedTabSelect === 0)
    && tabsListState.map((item) => item.id).includes(savedTabSelect)) {
      setSelectedIndex(savedTabSelect);
    }
  }, [savedTabSelect, tabsListState]);

  const shipmentConsignment = useMemo(() => () => (
    <>
      <ShipmentConsignment isHub={isHub}
                           isUseAZH={isUseAZH}
                           isUseCheckShiptoAddress={isUseCheckShiptoAddress}
                           isUseFIFO={isUseFIFO}
                           isUseM4={isUseM4}
                           plantId={plantId}
                           showTranspOrder={showTranspOrder}
      />
    </>
  ), [
    isHub,
    isUseAZH,
    isUseCheckShiptoAddress,
    isUseFIFO,
    isUseM4,
    plantId,
    showTranspOrder
  ]);

  const incomingConsignment = useMemo(() => () => (
    <>
      <IncomingConsignment plantId={plantId}
                           isUseM4={isUseM4}
                           isUseAZH={isUseAZH}
                           showTranspOrder={showTranspOrder}
      />
    </>
  ), [plantId, isUseM4, isUseAZH, showTranspOrder]);

  const reports = useMemo(() => () => (
    <Reports plantId={plantId} typeStock={1} />
  ), [plantId]);

  // const stockMetric = useMemo(() => () => (
  //   <StockMetric plantId={plantId} typeStock={1} />
  // ), [plantId]);

  const qrCodeTab = useMemo(() => () => (
    <>
      <QRCodeTab shippingType={1}
                 plantId={plantId}
                 isUseM4={isUseM4}
                 isUseAZH={isUseAZH}
                 showTranspOrder={showTranspOrder}
      />
    </>
  ), [plantId, isUseM4, isUseAZH, showTranspOrder]);

  const responsiblePerson = useMemo(() => () => (
    <ResponsiblePerson plantId={plantId} shippingType={1} />
  ), [plantId]);

  const editAct = useMemo(() => () => (
    <EditAct plantId={plantId} shippingType={1} />
  ), [plantId]);

  const orders = useMemo(() => () => (
    <SalesOrders plantId={plantId} />
  ), [plantId]);

  const messagesAdmin = useMemo(() => () => (
    <>
      <MessagesAdmin plantId={plantId} />
    </>
  ), [plantId]);

  const onSelectionChanged = useCallback(({
    name,
    value
  }) => {
    if (name === 'selectedIndex') {
      setSelectedIndex(value);
    }
  }, []);

  return (
    <>
      <PopupActMVP isUseM4={isUseM4} isUseAZH={isUseAZH} />
      <TabPanel selectedIndex={selectedIndex}
                onOptionChanged={onSelectionChanged}
                elementAttr={{ class: styles.tabs }}
                deferRendering={false}
                repaintChangesOnly
      >
        <Item render={shipmentConsignment} />
        <Item render={incomingConsignment} disabled={isAutoAcceptIncoming ? 'true' : ''} />
        <Item render={reports} />
        {/* <Item render={stockMetric} /> */}
        <Item />
        <Item render={qrCodeTab} />
        {/* временно отключили по просьбе Саблиной Алевтины,
        после релиза 6.7 решили включить всем */}
        <Item render={responsiblePerson} />
        <Item render={editAct} />
        {/* вкладка "Заказы" имеет tabSelect=11, так что вводим дополнительные Item,
        чтобы "Заказы" была 11-ой, начиная с 0  */}
        <Item />
        <Item />
        <Item />
        <Item />
        <Item render={orders} />
        <Item />
        <Item render={messagesAdmin} />
      </TabPanel>
    </>

  );
};

export default StockTabPanelConsignment;
